export default __webpack_public_path__ + "static/media/vehicle11.2553dd00.png";